import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  listMdModelbyID: {},
};

const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_LIST_BY_ID(state, payload) {
    state.listMdModelbyID = payload;
  },

  ADD_LIST(state, payload) {
    state.list.push(payload);
  },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING", value);
  },
  list: (store, params) => {
    store.state.loading = true;
    Service.get(`vehicle/md-models`, params).then((data) => {
      if (params.page) {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
      } else {
        store.commit("SET_LIST", data.body);
      }
      store.state.loading = false;
      return data.body;
    });
  },
  show: (store, params) => {
    store.state.loading = true;
    return Service.get(`vehicle/md-models/${params.id}`, params).then(
      (data) => {
        store.commit("SET_LIST_BY_ID", data.body);
        store.state.loading = false;
        return data.body;
      }
    );
  },

  add: (store, { mdModel, filter }) => {
    store.state.loading = true;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    return Service.post(`vehicle/md-models`, mdModel, config).then((data) => {
      store.commit("ADD_LIST", data.body);
      store.dispatch("list", filter);
      store.state.loading = false;
      return data.body;
    });
  },

  update: (store, { mdModel, filter }) => {
    store.state.loading = true;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    return Service.put(
      `vehicle/md-models/${mdModel?.id}`,
      mdModel,
      config
    ).then((data) => {
      store.commit("UPDATE_LIST", data.body);
      store.dispatch("list", filter);
      store.state.loading = false;
      return data.body;
    });
  },

  destroy: (store, params) => {
    store.state.loading = true;
    return Service.destroy(`vehicle/md-models/${params?.id}`).finally(
      () => (store.state.loading = false)
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  meta(state) {
    return state.meta;
  },
  listMdModels(state) {
    return state.list;
  },
  getMdModelById(state) {
    return state.listMdModelbyID;
  },
  activelistMdModels() {
    return state.list.filter((mdModel) => mdModel.is_active == true);
  },
};

const mdModels = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default mdModels;
